<div
  class="h-full min-h-0 overflow-hidden rounded-lg border border-gray-300 bg-white"
>
  <div class="h-full min-h-0 overflow-auto">
    <table
      class="min-w-[900px] sm:min-w-full border-separate border-spacing-0 text-sm text-gray-700"
    >
      <thead class="font-semibold">
        <tr>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
          >
            Invoice #
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100 cursor-pointer select-none hover:bg-slate-500"
            (click)="onHeaderClick('invoice_recipient_name')"
          >
            <div class="flex items-center gap-1">
              Payer
              <lib-sort-icon
                [active]="sortBy() === 'invoice_recipient_name'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100 cursor-pointer select-none hover:bg-slate-500"
            (click)="onHeaderClick('payee_name')"
          >
            <div class="flex items-center gap-1">
              Payee
              <lib-sort-icon
                [active]="sortBy() === 'payee_name'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100 cursor-pointer select-none hover:bg-slate-500"
            (click)="onHeaderClick('total_amount_minor')"
          >
            <div class="flex items-center gap-1">
              Total Amount
              <lib-sort-icon
                [active]="sortBy() === 'total_amount_minor'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
          >
            Paid Amount
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
          >
            Period
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100 cursor-pointer select-none hover:bg-slate-500"
            (click)="onHeaderClick('created_at')"
          >
            <div class="flex items-center gap-1">
              Created On
              <lib-sort-icon
                [active]="sortBy() === 'created_at'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
          >
            Status
          </th>

          <th class="sticky top-0 z-10 bg-slate-600 p-3 text-slate-100">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
        @for (invoice of invoices(); track invoice.id) {
        <tr class="text-sm transition-colors duration-150 hover:bg-gray-50">
          <td class="cursor-pointer p-3" (click)="viewInvoice.emit(invoice)">
            <div class="font-mono font-medium text-gray-900">
              {{ invoice.invoice_number }}
            </div>
          </td>

          <!-- Payer -->
          <td class="cursor-pointer p-3" (click)="viewInvoice.emit(invoice)">
            <div class="font-medium text-gray-900">
              {{ invoice.invoice_recipient_name }}
            </div>
          </td>

          <!-- Payee -->
          <td class="cursor-pointer p-3" (click)="viewInvoice.emit(invoice)">
            <div class="font-medium text-gray-900">
              {{ invoice.payee_name }}
            </div>
            <div class="mt-1 text-xs text-gray-500">
              {{ titleCase(invoice.payee_type) }}
            </div>
          </td>

          <!-- Total Amount -->
          <td class="p-3 whitespace-nowrap">
            {{ formatMoney(invoice.total_amount_minor, invoice.currency) }}
          </td>

          <!-- Paid Amount -->
          <td class="p-3 whitespace-nowrap">
            {{ formatMoney(invoice.paid_amount_minor, invoice.currency) }}
          </td>

          <!-- Period -->
          <td class="p-3 whitespace-nowrap">
            @if (invoice.period_start || invoice.period_end) {
            {{ formatDate(invoice.period_start) }} –
            {{ formatDate(invoice.period_end) }}
            } @else { – }
          </td>

          <!-- Created On -->
          <td class="p-3 whitespace-nowrap">
            {{ formatDateTime(invoice.created_at) }}
          </td>
          <td class="p-3 whitespace-nowrap">
            <lib-commission-invoice-status-badge [status]="invoice.status" />
          </td>

          <td class="p-3 text-right">
            @if (canView()) {
            <lib-view-icon-button
              title="View Invoice"
              variant="gray"
              size="md"
              (clicked)="viewInvoice.emit(invoice)"
            />
            }
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="9">
            <shared-no-records-placeholder
              title="No invoices found"
              description="Commission invoices will appear here once created."
            />
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
